import API from '@/api/index';

const sim = {
  state: {
    sims: [],
    totalSim: 0
  },

  mutations: {
    SET_SIMS: (state, sims) => { state.sims = sims },
    SET_TOTAL_SIMS: (state, totalSim) => { state.totalSim = totalSim }
  },

  actions: {
    getSims ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.sim
          .getSims(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let sims = result.data.data;
              commit('SET_SIMS', sims);
              commit('SET_TOTAL_SIMS', result.data.totalRecords);
              resolve(sims);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    
    getSimByIccId: ({ state }, value) => state.sims.find(a => a.iccId === value),

    searchSim ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.sim.searchSim(data).then(response => {
          let result = response.data;
          if (!result.code) resolve(result.data);
          else reject(result);
        }).catch(err => {
          reject(err);
        });
      });
    },
    
    importSims ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.sim
          .importSims(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let sims = result.data;
              resolve(sims);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    updateSim ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.sim
          .updateSim(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    moveSims ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.sim
          .moveSims(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    deleteSims ({ state }, ids) {
      return new Promise((resolve, reject) => {
        API.sim
          .deleteSims(ids)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    returnSims ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.sim
          .returnSims(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    
    updateSimData ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.sim
          .updateSimData(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getSimDataByTime ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.sim
          .getSimDataByTime(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default sim;



// WEBPACK FOOTER //
// ./src/store/modules/sim.js